import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef } from "react";
import { Form, Col, Row, Container } from "react-bootstrap";
import SearchResults from "./SearchResults";
import Wrapper from "../wrapper/Wrapper";
import Sidebar from "./Sidebar";
import { SearchHeader } from "./SearchHeader";
import { RetailHeading } from "../retail/RetailHeading";
import { PageCounter } from "../article/PageCounter";
import { useQueryParams, StringParam, NumberParam } from 'use-query-params';
import { debounce } from "lodash";
import MediaQuery from "react-responsive";
import { Loading } from "../state/Loading";
import { search } from "../../util/ga-analytics/events/search";
var layout = {
  background: "default",
  padding: "medium"
};

var Search = function Search(props) {
  var _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      _props$pageChange = props.pageChange,
      pageChange = _props$pageChange === void 0 ? function () {
    return console.log("pageChange");
  } : _props$pageChange,
      _props$termChange = props.termChange,
      termChange = _props$termChange === void 0 ? function () {
    return console.log("termChange");
  } : _props$termChange,
      _props$clearRail = props.clearRail,
      clearRail = _props$clearRail === void 0 ? function () {
    return console.log("clearRail");
  } : _props$clearRail,
      serverPageButtons = props.pageButtons,
      currentPage = props.currentPage,
      pageSize = props.pageSize,
      _props$resultsCountLa = props.resultsCountLabel,
      resultsCountLabel = _props$resultsCountLa === void 0 ? "" : _props$resultsCountLa,
      _props$resultsHeading = props.resultsHeading,
      resultsHeading = _props$resultsHeading === void 0 ? "" : _props$resultsHeading,
      _props$query = props.query,
      query = _props$query === void 0 ? "" : _props$query,
      _props$total = props.total,
      total = _props$total === void 0 ? 0 : _props$total,
      _props$topicChange = props.topicChange,
      topicChange = _props$topicChange === void 0 ? function () {
    return console.log("topicChange -- SEARCH");
  } : _props$topicChange,
      _props$categoriesChan = props.categoriesChange,
      categoriesChange = _props$categoriesChan === void 0 ? function () {
    return console.log("categoryChange -- SEARCH");
  } : _props$categoriesChan,
      _props$priceChange = props.priceChange,
      priceChange = _props$priceChange === void 0 ? function () {
    return console.log("priceChange -- SEARCH");
  } : _props$priceChange,
      _props$modifierChange = props.modifierChange,
      modifierChange = _props$modifierChange === void 0 ? function () {
    return console.log("modifierChange -- SEARCH");
  } : _props$modifierChange,
      _props$pageSizeSet = props.pageSizeSet,
      pageSizeSet = _props$pageSizeSet === void 0 ? function () {
    return console.log("pageSize");
  } : _props$pageSizeSet,
      _props$setDataSource = props.setDataSource,
      setDataSource = _props$setDataSource === void 0 ? function () {
    return console.log("dataSource");
  } : _props$setDataSource,
      _props$facets = props.facets,
      facets = _props$facets === void 0 ? [] : _props$facets,
      _props$sortByOptions = props.sortByOptions,
      sortByOptions = _props$sortByOptions === void 0 ? [] : _props$sortByOptions,
      _props$sortByChange = props.sortByChange,
      sortByChange = _props$sortByChange === void 0 ? function () {
    return "";
  } : _props$sortByChange,
      _props$isRetail = props.isRetail,
      isRetail = _props$isRetail === void 0 ? false : _props$isRetail,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading;

  var _useQueryParams = useQueryParams({
    query: StringParam,
    page: NumberParam
  }),
      _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
      _useQueryParams2$ = _useQueryParams2[0],
      queryParam = _useQueryParams2$.query,
      pageParam = _useQueryParams2$.page,
      filterParam = _useQueryParams2$.filters,
      setQuery = _useQueryParams2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isGrid = _useState2[0],
      setGrid = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      heading = _useState4[0],
      setHeading = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      label = _useState6[0],
      setLabel = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasLoadedOnce = _useState8[0],
      setHasLoadedOnce = _useState8[1];

  var searchRef = useRef(null);
  useEffect(function () {
    // setGrid(isRetail)
    setGrid(true);
  }, [isRetail]);
  useEffect(function () {
    var heading = resultsHeading.replace("{0}", queryParam || query);
    setHeading(heading);
    var currentProduct = currentPage * pageSize;
    var label = resultsCountLabel.replace("{0}", results.length ? "".concat(currentProduct + 1, " - ").concat(currentProduct + results.length) : results.length).replace("{1}", total);
    setLabel(label);
  }, [queryParam, query, results]);
  var CategoryArray = sortByOptions.map(function (option) {
    var _option$fields, _option$fields2;

    return {
      value: (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : _option$fields.key.value,
      label: (_option$fields2 = option.fields) === null || _option$fields2 === void 0 ? void 0 : _option$fields2.value.value
    };
  });

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isFirst = _useState10[0],
      setIsFirst = _useState10[1];

  var termChangeWrapper = debounce(function (value) {
    if (!isFirst && value) {
      search(value);
    }

    setIsFirst(false);
    setQuery({
      query: value
    });
    termChange(value);
  }, 700);
  useEffect(function () {
    if (pageSize) {
      var _props$rendering;

      pageSizeSet(pageSize);
      setDataSource((_props$rendering = props.rendering) === null || _props$rendering === void 0 ? void 0 : _props$rendering.dataSource);

      if (!isRetail) {
        clearRail(); //If no queryParam it will just pull back facets
      }

      if (queryParam || isRetail) {
        termChangeWrapper(queryParam); //If no queryParam it will just pull back facets
      }
    }
  }, [pageSize]);

  var pageChangeWrapper = function pageChangeWrapper(e) {
    setQuery({
      page: e + 1
    });
    pageChange(e);

    if (searchRef.current) {
      searchRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: isRetail ? "cb-retail__landing" : ""
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-search__container"
  }, /*#__PURE__*/React.createElement(Row, {
    ref: searchRef
  }, //This is for retail view
  isRetail && /*#__PURE__*/React.createElement(Col, {
    lg: "12"
  }, /*#__PURE__*/React.createElement(RetailHeading, _extends({}, props, {
    heading: heading,
    label: label,
    CategoryArray: CategoryArray,
    sortByChange: sortByChange,
    modifierChange: modifierChange,
    setGrid: setGrid,
    isGrid: isGrid
  }))), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "3",
    className: "cb-search-sidebar--border"
  }, /*#__PURE__*/React.createElement(Sidebar, props))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    },
    className: "cb-search-results__form"
  }, !isRetail && /*#__PURE__*/React.createElement(SearchHeader, _extends({}, props, {
    heading: heading,
    label: label,
    CategoryArray: CategoryArray,
    termChange: termChangeWrapper,
    sortByChange: sortByChange,
    setGrid: setGrid,
    isGrid: isGrid
  })), loading && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: loading
  })), !Boolean(results.length) && !loading && /*#__PURE__*/React.createElement("div", {
    className: "h-100 cb-location-finder__no-locations"
  }, /*#__PURE__*/React.createElement("h2", null, "No results found, please ", isRetail ? "try a new category" : "retry your search")), Boolean(results.length) && !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchResults, _extends({}, props, {
    isGrid: isGrid,
    results: results,
    pageChange: pageChange,
    total: total,
    currentPage: currentPage,
    fields: {},
    isRetail: isRetail,
    hasLoadedOnce: hasLoadedOnce,
    setHasLoadedOnce: setHasLoadedOnce
  }))), Boolean(results.length) && /*#__PURE__*/React.createElement(PageCounter, {
    totalPages: Math.ceil(total / pageSize),
    handleChange: pageChangeWrapper,
    currentPage: currentPage
  }))))));
};

export default Search;